import React from "react";
import SEOLandingPage from "./SEOLandingPage";

const SqliteViewerAndroid: React.FC = () => (
  <SEOLandingPage
    title="SQLite Viewer for Android — Browse & Query SQLite Databases on Mobile | Cosmovex"
    metaDescription="SQLite Viewer & Editor for Android. Open SQLite database files, browse tables, run SQL queries, and export data — all on your phone without a laptop."
    ogTitle="SQLite Viewer for Android — SQLVEdit"
    h1="SQLite Viewer for Android"
    intro="Open any SQLite database file on your phone, browse its tables, and run SQL queries instantly. SQLVEdit brings proper database tooling to Android."
    paragraphs={[
      "SQLite is everywhere — Android apps, embedded systems, local storage in browsers, and backend services all use it. SQLVEdit lets you open and inspect those .db and .sqlite files directly on your phone without needing a laptop or a GUI tool like DB Browser.",
      "Once you open a database, you get a full table browser showing all tables, their schemas, and the data within. Row counts, column types, primary keys, indexes — everything you'd see in a desktop SQLite viewer is available in a mobile-first UI designed for touch.",
      "The SQL editor is where SQLVEdit earns its place as a serious tool. You can write queries from simple SELECT statements to complex JOINs, subqueries, and aggregations. Results appear in a paginated table below. Errors show with helpful messages pointing to where the SQL went wrong.",
      "For developers debugging Android apps, this is especially useful. App databases are stored in the app's data directory, and SQLVEdit can open exported copies for inspection. You can verify that your app's database schema looks right, check data integrity, or spot unexpected nulls without connecting to a computer.",
    ]}
    features={[
      "Open SQLite .db and .sqlite files from storage",
      "Browse all tables with schema and row counts",
      "Full SQL query editor with syntax highlighting",
      "Results displayed in paginated table view",
      "Create, drop, and alter tables",
      "INSERT, UPDATE, DELETE with visual feedback",
      "Export query results to CSV",
      "Database integrity check tool",
      "Works offline — no cloud sync",
      "Support for large databases with efficient paging",
    ]}
    playStoreUrl="https://play.google.com/store/apps/details?id=com.cosmovex.sqlvedit"
    icon="/images/sqlvedit.png"
    appName="SQLVEdit"
    accentColor="#A8720E"
    canonicalPath="/sqlite-viewer-android"
  />
);

export default SqliteViewerAndroid;
